"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncStatusResult = exports.Async = void 0;
const cbor_1 = __importDefault(require("cbor"));
const const_1 = require("../../../const");
const identity_1 = require("../../../identity");
const message_1 = require("../../../message");
const cose_1 = require("../../../message/cose");
const utils_1 = require("../../../utils");
const network_1 = require("../../network");
const sleep = async (time) => new Promise(r => setTimeout(r, time));
exports.Async = {
    _namespace_: "async",
    async handleAsyncToken(message, n) {
        const asyncToken = message.getAsyncToken();
        return asyncToken
            ? await pollAsyncStatus(n !== null && n !== void 0 ? n : new network_1.Network(this.url, new identity_1.AnonymousIdentity()), asyncToken)
            : message;
    },
};
var AsyncStatusResult;
(function (AsyncStatusResult) {
    AsyncStatusResult[AsyncStatusResult["Unknown"] = 0] = "Unknown";
    AsyncStatusResult[AsyncStatusResult["Queued"] = 1] = "Queued";
    AsyncStatusResult[AsyncStatusResult["Processing"] = 2] = "Processing";
    AsyncStatusResult[AsyncStatusResult["Done"] = 3] = "Done";
    AsyncStatusResult[AsyncStatusResult["Expired"] = 4] = "Expired";
})(AsyncStatusResult = exports.AsyncStatusResult || (exports.AsyncStatusResult = {}));
function parseAsyncStatusPayload(cbor) {
    const index = cbor.get(0);
    if (typeof index != "number") {
        throw new Error("Invalid async result");
    }
    if (!(index in AsyncStatusResult)) {
        throw Error("Invalid async result");
    }
    const result = index;
    let payload = undefined;
    if (result === AsyncStatusResult.Done) {
        payload = cbor.get(1);
        if (!payload || !Buffer.isBuffer(payload)) {
            throw Error("Invalid async result");
        }
    }
    return { result, payload };
}
async function pollAsyncStatus(n, asyncToken, options = {}) {
    var _a, _b;
    const timeoutInMsec = (_a = options.timeoutInMsec) !== null && _a !== void 0 ? _a : const_1.ONE_MINUTE;
    let waitTimeInMsec = (_b = options.waitTimeInMsec) !== null && _b !== void 0 ? _b : const_1.ONE_SECOND;
    const end = +new Date() + timeoutInMsec;
    while (true) {
        const res = (await n.call("async.status", new Map([[0, asyncToken]])));
        const result = parseAsyncStatusPayload(res.getPayload());
        switch (result.result) {
            case AsyncStatusResult.Done:
                let payload = cbor_1.default.decode(result.payload, cose_1.decoders);
                if (Array.isArray(payload)) {
                    payload = cbor_1.default.decode(payload === null || payload === void 0 ? void 0 : payload[2], cose_1.decoders);
                }
                return (0, utils_1.throwOnErrorResponse)(new message_1.Message(payload === null || payload === void 0 ? void 0 : payload.value));
            case AsyncStatusResult.Expired:
                throw new Error("Async Expired before getting a result");
        }
        if (Date.now() >= end) {
            return res;
        }
        await sleep(waitTimeInMsec);
        waitTimeInMsec *= 1.5;
    }
}
